require('./accountSettlementsDetailsTableRow.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { HYPHEN, PERCENTAGE_SYMBOL, DATE_FORMAT_ES } = require('constants/index');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
//@core
const { getLanguage } = require('core/i18n').i18n;
// @ helpers
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const DateHelper = require('utilities/dateHelper');

class AccountSettlementsDetailsTableRow extends React.Component {

    constructor(props){
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    formatDateFromPeriod(dateStr) {
        return DateHelper.buildFormattedDate(dateStr, DATE_FORMAT_ES);
    }

    render() {
        const { immTransaction, id } = this.props;
        let dateFrom, dateTo, concept, rate, amount;

        if (immTransaction) {
            dateFrom = this.formatDateFromPeriod(immTransaction.get('dateFrom'));
            dateTo = this.formatDateFromPeriod(immTransaction.get('dateTo'));
            concept = immTransaction.get('concept');
            rate = immTransaction.get('rate');
            amount = immTransaction.get('amount');
        }

        const plainAmountObject = getPlainAmountObject(amount);

        return (
            <OKTableRow id={id}>
                <OKTableCell>
                    {dateFrom} {HYPHEN} {dateTo}
                </OKTableCell>
                <OKTableCell>
                    {concept}
                </OKTableCell>
                <OKTableCell className="account-settlements-details-table-row__cell--right">
                    {rate} {PERCENTAGE_SYMBOL}
                </OKTableCell>
                <OKTableCell className="account-settlements-details-table-row__cell--right account-settlements-details-table-row__cell--currency">
                    <OneLineSymbolAmount
                        amountObject={plainAmountObject}
                        language={getLanguage()}
                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                    />
                </OKTableCell>
            </OKTableRow>
        )
    }
}

AccountSettlementsDetailsTableRow.propTypes = {
    immTransaction: PropTypes.object,
    id: PropTypes.string,
    onRowClick: PropTypes.func
}

AccountSettlementsDetailsTableRow.defaultProps = {
    className: '',
    onRowClick: function() {}
}

module.exports = AccountSettlementsDetailsTableRow;